

// global variables

if (typeof storefrontAccessToken === "undefined") {
  var storefrontAccessToken = "beb7e070a5cb08fe7b7e7606c88af246"; 
  
} 

if (typeof bodyClasses === "undefined") {
  var bodyClasses = document.body.className;
  // console.log("Declared bodyClasses:", bodyClasses);
}


// if template Product
if (bodyClasses.includes('product-page-loaded')) {  

relatedProduct();

function slickSlider() {
  $(".relatedProduct").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 2300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

} // end if condition of template


// if template Index
if (bodyClasses.includes('template-index')) {  
//    Home Slider    //
if ($(".laberSlidershow .grid-slider").length) {
    $(".laberSlidershow .grid-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
} else {
    console.error("Element .laberSlidershow .grid-slider not found!");
}


//    Related Product Slider PDPage


//        Search filter       //

async function getApiProData(product_tag,searchval,brandname) {


  
  // console.log("product_tag>>",product_tag,"searchval>>",searchval,"brandname>>",brandname)
  
  var query = '';
  
  if(product_tag && searchval && brandname ){
    query += "vendor:'"+brandname+"' AND tag:'"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part "; 
  }else if(searchval && product_tag){
     query += "tag:'"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part"; 
  }else if(brandname  && product_tag ){
    // query += "vendor:'"+brandname+"'";
    query += "vendor:'"+brandname+"' AND tag:'"+product_tag+"' AND product_type:Part"; 
  }else if(product_tag != '' && !brandname && !searchval ){
    // console.log("product_tag>>><<<<<",product_tag)
    query += "tag:'"+product_tag+"' AND product_type:Part"; 
  }
  else{
    // console.log("else else")
   // query +=   "title:'"+searchval+"'";
  }

  // console.log("query",query)
  // console.log("product_tag inside the function api ", product_tag)
  // console.log("search_tag inside the function api ", search_tag);

  const response = fetch(
    "https://appliancepartstore.myshopify.com/api/2023-04/graphql.json",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
      },

      body: JSON.stringify({
        query: `{
                  products(
                    first: 30
                    query: "${query}"
                  ) {
                    nodes {
                            title
                            tags
                            productType
                            id
                            vendor
                            handle
                            images(first: 10) {
                              nodes {
                                originalSrc
                              }
                            }
                            variants(first: 10) {
                              nodes {
                                id
                                price {
                                  amount
                                }
                                sku
                              }
                            }    
                          }
                  }
                }
                                            `,
      }),
    }
  )
    // console.log("response",response)

    // const result = await response.json();
    .then((response) => response.json()) // Resolving the JSON promise
    .then((data) => {
      // console.log("response444>>>", data);
      if (data.data.products.nodes.length === 0) 
      {
      // Perform an action when nodes are empty
      // console.log("No products available.");
        $('.suggestion-list').addClass('hidden-important')
         $('.mesaage_forData').css('display','block')
        //  if ($('.suggestion-list').hasClass('hidden-important')) {
        //   $('.mesaage_forData').css('display','none !important');
        //    $('.suggestion-list').removeClass('hidden-important')
        // }else{
        //    $('.mesaage_forData').css('display','block')
        //    $('.suggestion-list').addClass('hidden-important')
        //    $('.loader_filter').css('display','none')
        // }
      }else{
       $('.loaderfilter').show();
        const $slider = $(".suggestion-list");
        $slider.removeClass('hidden-important')
        $slider.html(``)
        
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        // console.log("else display")
        $('.mesaage_forData').css('display','none');
        const product_search = data?.data?.products;
        var Brand_json = [
          { lineCode: "ZEN", Brand: "1LG" },
          { lineCode: "BRT", Brand: "Bertazzoni" },
          { lineCode: "SMG", Brand: "Samsung" },
          { lineCode: "AAC", Brand: "ARCTIC AIR C" },
          { lineCode: "ABT", Brand: "ABBOTT" },
          { lineCode: "ABU", Brand: "Abu Garcia" },
          { lineCode: "ACE", Brand: "AIRTOUCH" },
          { lineCode: "ACF", Brand: "ALL FILTERS" },
          { lineCode: "ACP", Brand: "ACP" },
          { lineCode: "ACR", Brand: "ACER" },
          { lineCode: "ACU", Brand: "ACCU SHARP" },
          { lineCode: "ACX", Brand: "ACER REFURB" },
          { lineCode: "AEL", Brand: "AERIS ENVIRONMENTAL" },
          { lineCode: "AFF", Brand: "AFFINITY" },
          { lineCode: "AGA", Brand: "AGA MARVEL" },
          { lineCode: "AGR", Brand: "AGRI-FAB" },
          { lineCode: "A  IP", Brand: "AIPHONE" },
          { lineCode: "AIR", Brand: "AIRWELL FEDDERS" },
          { lineCode: "AIW", Brand: "AIWA" },
          { lineCode: "AKI", Brand: "AKAI" },
          { lineCode: "ALH", Brand: "ALPHA" },
          { lineCode: "ALP", Brand: "ALPINE" },
          { lineCode: "ALR", Brand: "ALARIS" },
          { lineCode: "AMA", Brand: "AMANA COMMERICAL" },
          { lineCode: "AME", Brand: "AMERICAN LAWN" },
          { lineCode: "AMF", Brand: "AMERICAN METAL FILTE" },
          { lineCode: "AMS", Brand: "AMERICAN STANDARD" },
          { lineCode: "AMT", Brand: "AIRMASTER" },
          { lineCode: "AND", Brand: "ANDIS" },
          { lineCode: "ANR", Brand: "AEONAIR" },
          { lineCode: "AOC", Brand: "AOC/EPI" },
          { lineCode: "APA", Brand: "APPLE REPLACEMENT" },
          { lineCode: "APL", Brand: "APL" },
          { lineCode: "APX", Brand: "APEX" },
          { lineCode: "ARC", Brand: "ARCLYTE TECHNOLOGIES" },
          { lineCode: "ARD", Brand: "ARDISAM" },
          { lineCode: "ARI", Brand: "Ariens Company" },
          { lineCode: "ARK", Brand: "AIR KING" },
          { lineCode: "ARM", Brand: "ARMSTRONG" },
          { lineCode: "ARR", Brand: "ARRCO LLC" },
          { lineCode: "ASK", Brand: "ASKO" },
          { lineCode: "ASU", Brand: "Asus" },
          { lineCode: "ASR", Brand: "ASUS REFURB" },
          { lineCode: "AST", Brand: "ASTI" },
          { lineCode: "ATR", Brand: "ASTRA" },
          { lineCode: "AVA", Brand: "AVANTI PRODUCTS" },
          { lineCode: "AVT", Brand: "AVENT" },
          { lineCode: "BAC", Brand: "BACKER EHP" },
          { lineCode: "BAD", Brand: "BAD PART NUMBER" },
          { lineCode: "BAR", Brand: "B-AIR" },
          { lineCode: "BAT", Brand: "HIGH CAPACITY" },
          { lineCode: "BAX", Brand: "BAXTER" },
          { lineCode: "BBD", Brand: "BLUEBIRD" },
          { lineCode: "BBN", Brand: "BRAUN (DELONGHI)" },
          { lineCode: "BCH", Brand: "BOSCH" },
          { lineCode: "BCH", Brand: "Bosch Commerical" },
          { lineCode: "BDR", Brand: "BLUEDRI" },
          { lineCode: "BEC", Brand: "BECKMAN INDUSTRIAL" },
          { lineCode: "BEL", Brand: "0" },
          { lineCode: "BEN", Brand: "BENQ USA" },
          { lineCode: "BER", Brand: "BLUE EMBER" },
          { lineCode: "BGR", Brand: "B GREEN INNOVATIONS" },
          { lineCode: "BGT", Brand: "BLODGETT" },
          { lineCode: "BIE", Brand: "BIESEMEYER" },
          { lineCode: "BIO", Brand: "BIONAIRE" },
          { lineCode: "BIS", Brand: "BISSELL" },
          { lineCode: "BKS", Brand: "BROOKSTONE" },
          { lineCode: "BLA", Brand: "BLACK & DECKER" },
          { lineCode: "BLK", Brand: "BROIL KING" },
          { lineCode: "BLM", Brand: "BLOMBERG" },
          { lineCode: "BLO", Brand: "" },
          { lineCode: "BLR", Brand: "BRITELITE REFURBISH" },
          { lineCode: "BLT", Brand: "BRILLIANT SCENTS" },
          { lineCode: "BLU", Brand: "BLU PRODUCTS" },
          { lineCode: "BMR", Brand: "BROILMASTER" },
          { lineCode: "BOL", Brand: "BOLENS" },
          { lineCode: "BOS", Brand: "BOSE" },
          { lineCode: "BOX", Brand: "BOXES" },
          { lineCode: "BQN", Brand: "BINATONE ELECTRONICS" },
          { lineCode: "BRA", Brand: "BRAUN" },
          { lineCode: "BRD", Brand: "BARRANCA DIAMOND" },
          { lineCode: "BRE", Brand: "BREVILLE" },
          { lineCode: "BRI", Brand: "BRISTOL" },
          { lineCode: "BRK", Brand: "BROKSONIC" },
          { lineCode: "BRL", Brand: "BRILLIANT INK & TONE" },
          { lineCode: "BRM", Brand: "BROIL-MATE" },
          { lineCode: "BRN", Brand: "BROAN" },
          { lineCode: "BRO", Brand: "BROTHER" },
          { lineCode: "BRR", Brand: "BROTHER REFURB" },
          { lineCode: "BRS", Brand: "BROWN STOVE" },
          { lineCode: "BRT", Brand: "BERTAZZONI" },
          { lineCode: "BRY", Brand: "BARRY RESTORE IT ALL" },
          { lineCode: "BSA", Brand: "BOSTON ACOUSTICS" },
          { lineCode: "BSG", Brand: "BRIGGS POWER" },
          { lineCode: "BSH", Brand: "BOSCH TOOLS" },
          { lineCode: "BSM", Brand: "MURRAY" },
          { lineCode: "BSP", Brand: "BRIGGS STRATTON" },
          { lineCode: "BTH", Brand: "BOSTITCH" },
          { lineCode: "BTI", Brand: "BATTERY TECHNOLOGY" },
          { lineCode: "BUN", Brand: "BUNN" },
          { lineCode: "BWL", Brand: "BOWERS WILKINS" },
          { lineCode: "CA1", Brand: "CANON CONSUMER" },
          { lineCode: "CA2", Brand: "CANON CAMERA" },
          { lineCode: "CAF", Brand: "CAFE GE APPLIANCE" },
          { lineCode: "CAL", Brand: "CALPHALON" },
          { lineCode: "CAN", Brand: "CANON" },
          { lineCode: "CAR", Brand: "CARRIER" },
          { lineCode: "CAS", Brand: "CASIO" },
          { lineCode: "CAX", Brand: "CANON REFURB" },
          { lineCode: "CBC", Brand: "CRARY BEAR CAT" },
          { lineCode: "CBL", Brand: "CHAR-BROIL" },
          { lineCode: "CBY", Brand: "COBY (REFURBISH)" },
          { lineCode: "CCF", Brand: "CAMP CHEF" },
          { lineCode: "CCS", Brand: "CIRCUIT CITY SERVICE" },
          { lineCode: "CEL", Brand: "CELL PHONE" },
          { lineCode: "CGI", Brand: "GREEN CHOICE" },
          { lineCode: "CHA", Brand: "CHAMPION" },
          { lineCode: "CHD", Brand: "CAMPBELL HAUSFELD" },
          { lineCode: "CHE", Brand: "CHEMTRONICS" },
          { lineCode: "CHI", Brand: "CHIPQUIK" },
          { lineCode: "CHL", Brand: "CHAMBERLAIN" },
          { lineCode: "CKP", Brand: "CYBERKITS" },
          { lineCode: "CLA", Brand: "Classen" },
          { lineCode: "CLC", Brand: "CLECO" },
          { lineCode: "CLE", Brand: "CLEVELAND" },
          { lineCode: "CLO", Brand: "CIELO" },
          { lineCode: "CLP", Brand: "CALSPA" },
          { lineCode: "CLR", Brand: "CLARION" },
          { lineCode: "COL", Brand: "COLEMAN" },
          { lineCode: "COM", Brand: "COMPUTER" },
          { lineCode: "CON", Brand: "CONTINENTAL FAN" },
          { lineCode: "COO", Brand: "COOPER" },
          { lineCode: "CPC", Brand: "CHICAGO PNEUMATIC" },
          { lineCode: "CPN", Brand: "CHAPIN" },
          { lineCode: "CPQ", Brand: "COMPAQ" },
          { lineCode: "CPX", Brand: "COMPAQ REFURB" },
          { lineCode: "CRA", Brand: "CRAFTSMAN" },
          { lineCode: "CRC", Brand: "CRES COR" },
          { lineCode: "CRO", Brand: "CROWN ELECTRONICS" },
          { lineCode: "CRP", Brand: "CROCK POT" },
          { lineCode: "CRS", Brand: "CROSLEY" },
          { lineCode: "CUB", Brand: "Cub Cadet" },
          { lineCode: "CUI", Brand: "CUISINART" },
          { lineCode: "CUR", Brand: "CURLIN" },
          { lineCode: "CYB", Brand: "CYBEX" },
          { lineCode: "DAC", Brand: "DACOR" },
          { lineCode: "DAE", Brand: "Kenmore" },
          { lineCode: "DAM", Brand: "DAMAGED PANELS" },
          { lineCode: "DBY", Brand: "DANBY" },
          { lineCode: "DEF", Brand: "DEFLECT-0" },
          { lineCode: "DEG", Brand: "DELONGHI REPLACEMENT" },
          { lineCode: "DEI", Brand: "DELONGHI" },
          { lineCode: "DEL", Brand: "DELL" },
          { lineCode: "DEN", Brand: "DENON" },
          { lineCode: "DER", Brand: "DELL REFURB" },
          { lineCode: "DEV", Brand: "DEVILBISS" },
          { lineCode: "DEW", Brand: "DEWALT" },
          { lineCode: "DFD", Brand: "DELFIELD" },
          { lineCode: "DFT", Brand: "DEFINITIVE TECH" },
          { lineCode: "DIG", Brand: "DIGITENNA" },
          { lineCode: "DIR", Brand: "DIRT DEVIL" },
          { lineCode: "DIV", Brand: "DIVERSITECH INC" },
          { lineCode: "DML", Brand: "DREMEL" },
          { lineCode: "DNG", Brand: "DNGO INTERNATIONAL" },
          { lineCode: "DOR", Brand: "DORMONT MANUFACTURIN" },
          { lineCode: "DOT", Brand: "DOTCO" },
          { lineCode: "DRA", Brand: "D&R ASSOCIATES INC." },
          { lineCode: "DRE", Brand: "DR POWER EQUIPMENT" },
          { lineCode: "DRG", Brand: "HEAT TOOLS" },
          { lineCode: "DSS", Brand: "DSS" },
          { lineCode: "DTF", Brand: "DELTA FAUCET" },
          { lineCode: "DTL", Brand: "DELTA" },
          { lineCode: "DTP", Brand: "GREEN CHOICE" },
          { lineCode: "DUN", Brand: "DUNDAS JAFINE INC" },
          { lineCode: "DUR", Brand: "DURACELL U.S.A." },
          { lineCode: "DUS", Brand: "DUSTLESS" },
          { lineCode: "DXR", Brand: "DEX REFURBISHED" },
          { lineCode: "DYB", Brand: "DYNABRADE" },
          { lineCode: "DYS", Brand: "DYSON" },
          { lineCode: "ECH", Brand: "ECHO" },
          { lineCode: "ECL", Brand: "ECLIPSE" },
          { lineCode: "ECO", Brand: "FILTERS" },
          { lineCode: "EDI", Brand: "EDIC" },
          { lineCode: "EGO", Brand: "EGO" },
          { lineCode: "EGR", Brand: "GREEN CHOICE" },
          { lineCode: "ELE", Brand: "ELENCO ELECTRONICS" },
          { lineCode: "ELI", Brand: "ELICA" },
          { lineCode: "ELR", Brand: "ELECTRONIC RESOURCES" },
          { lineCode: "ELS", Brand: "GENERIC" },
          { lineCode: "ELX", Brand: "ELECTROLUX PRO" },
          { lineCode: "EMA", Brand: "E-MACHINE" },
          { lineCode: "EME", Brand: "EMERSON" },
          { lineCode: "EMP", Brand: "EMPIRE VIDEO" },
          { lineCode: "EMR", Brand: "EMACHINES REFURB" },
          { lineCode: "ENR", Brand: "ENVISION REFURBISHED" },
          { lineCode: "ENV", Brand: "ENVISION" },
          { lineCode: "EPD", Brand: "ENCOMPASS PARTS" },
          { lineCode: "EPR", Brand: "EPSON REFURB" },
          { lineCode: "EPS", Brand: "EPSON" },
          { lineCode: "ERK", Brand: "EUREKA" },
          { lineCode: "ERP", Brand: "GENERIC REPLACEMENT" },
          { lineCode: "ESC", Brand: "ESCORT" },
          { lineCode: "ESI", Brand: "TILE" },
          { lineCode: "ESP", Brand: "ESPRESSO ACCESSORIES" },
          { lineCode: "ESS", Brand: "ENCOMPASS SERVICE" },
          { lineCode: "EVE", Brand: "EVEREADY BATTERY CO." },
          { lineCode: "EXM", Brand: "EXMARK" },
          { lineCode: "EZF", Brand: "EZ-FLO" },
          { lineCode: "FAM", Brand: "FAMOUS ENTREPRISES" },
          { lineCode: "FAN", Brand: "FANTOM" },
          { lineCode: "FAP", Brand: "FISHER & PAYKEL" },
          { lineCode: "FAS", Brand: "FASCO" },
          { lineCode: "FBT", Brand: "REPLACEMENT FBT" },
          { lineCode: "FEI", Brand: "FEIN" },
          { lineCode: "FIE", Brand: "FIESTA" },
          { lineCode: "FJT", Brand: "FUJITSU" },
          { lineCode: "FLE", Brand: "FLEX" },
          { lineCode: "FLO", Brand: "FLOTEC" },
          { lineCode: "FLU", Brand: "FLUKE" },
          { lineCode: "FMN", Brand: "Freemotion" },
          { lineCode: "FNA", Brand: "SIMPSON DELCO" },
          { lineCode: "FOX", Brand: "FOXCONN" },
          { lineCode: "FPL", Brand: "FRONT PROJECTOR LAMP" },
          { lineCode: "FRE", Brand: "FREUDENBERG FILTRATI" },
          { lineCode: "FRI", Brand: "ELECTROLUX" },
          { lineCode: "FRY", Brand: "FRYMASTER" },
          { lineCode: "FUN", Brand: "FUNAI" },
          { lineCode: "FXA", Brand: "Fuji-Xerox Artermark" },
          { lineCode: "GAL", Brand: "GALPA EXPORT" },
          { lineCode: "GAM", Brand: "GAMING PARTS" },
          { lineCode: "GAR", Brand: "GARMIN" },
          { lineCode: "GAT", Brand: "GATEWAY" },
          { lineCode: "GCE", Brand: "GC-THORSEN" },
          { lineCode: "GCP", Brand: "GREEN CHOICE" },
          { lineCode: "GDG", Brand: "GOLDS GYM" },
          { lineCode: "GEA", Brand: "GE APPLIANCE PRODUCT" },
          { lineCode: "GEM", Brand: "HVAC PARTS" },
          { lineCode: "GEN", Brand: "GENERAC DELCO" },
          { lineCode: "GGL", Brand: "GOOGLE" },
          { lineCode: "GIC", Brand: "GET IT CLEAN" },
          { lineCode: "GIL", Brand: "GILLETTE" },
          { lineCode: "GLN", Brand: "GARLAND" },
          { lineCode: "GLT", Brand: "PHILIP PERSONAL CARE" },
          { lineCode: "GNE", Brand: "GENIE" },
          { lineCode: "GOL", Brand: "GOLIATH" },
          { lineCode: "GOO", Brand: "GOODMAN" },
          { lineCode: "GOP", Brand: "GO PLUS LIGHTING" },
          { lineCode: "GOV", Brand: "GO VIDEO" },
          { lineCode: "GPR", Brand: "GRIP-RITE" },
          { lineCode: "GPS", Brand: "GPS BATTERIES" },
          { lineCode: "GPX", Brand: "GPX REMOTES" },
          { lineCode: "GRA", Brand: "GRACO" },
          { lineCode: "GRI", Brand: "GRINDMASTER" },
          { lineCode: "GRN", Brand: "GREENWORKS" },
          { lineCode: "GRO", Brand: "GROEN" },
          { lineCode: "GSA", Brand: "GE SMALL APPLIANCE" },
          { lineCode: "GTW", Brand: "GATEWAY REFURB" },
          { lineCode: "GUA", Brand: "GUARDSMAN" },
          { lineCode: "HAB", Brand: "HABEGGER CORP" },
          { lineCode: "HAD", Brand: "Honda Marine" },
          { lineCode: "HAI", Brand: "HAIER" },
          { lineCode: "HAK", Brand: "AMERICAN HAKKO" },
          { lineCode: "HAM", Brand: "HAMILTON BEACH" },
          { lineCode: "HAN", Brand: "HANNSPREE" },
          { lineCode: "HAR", Brand: "HARMON KARDON" },
          { lineCode: "HAT", Brand: "HATCO" },
          { lineCode: "HAY", Brand: "HAYWARD" },
          { lineCode: "HCT", Brand: "HCT" },
          { lineCode: "HCU", Brand: "HYUNDAI CORPORATION" },
          { lineCode: "HEA", Brand: "HEATSTAR" },
          { lineCode: "HEM", Brand: "HP/CANON" },
          { lineCode: "HEW", Brand: "HP" },
          { lineCode: "HHG", Brand: "HEAT HOG" },
          { lineCode: "HIS", Brand: "HISENSE" },
          { lineCode: "HIT", Brand: "HITACHI" },
          { lineCode: "HKC", Brand: "HKC DIGITAL" },
          { lineCode: "HKY", Brand: "HUSKY" },
          { lineCode: "HNP", Brand: "HENNY PENNY" },
          { lineCode: "HNS", Brand: "HANNSPREE REFURB" },
          { lineCode: "HOB", Brand: "HOBART" },
          { lineCode: "HOL", Brand: "HOLMAN" },
          { lineCode: "HOM", Brand: "Homelite" },
          { lineCode: "HON", Brand: "HONDA" },
          { lineCode: "HOO", Brand: "HOOVER" },
          { lineCode: "HOP", Brand: "AYP CRAFTSMAN" },
          { lineCode: "HOR", Brand: "HORTON VALVES" },
          { lineCode: "HOS", Brand: "HOSPIRA" },
          { lineCode: "HOT", Brand: "GE" },
          { lineCode: "HPA", Brand: "HP AFTERMARKET" },
          { lineCode: "HPC", Brand: "HP CANON OEM" },
          { lineCode: "HPR", Brand: "HP REFURBISHED" },
          { lineCode: "HPT", Brand: "METABO HPT" },
          { lineCode: "HRD", Brand: "HEALTH RIDER" },
          { lineCode: "HSL", Brand: "HAIER LITERATURE" },
          { lineCode: "HSR", Brand: "HEAT STREAM" },
          { lineCode: "HTC", Brand: "HTC CELLPHONES" },
          { lineCode: "HTG", Brand: "HUNTINGTON GRILL" },
          { lineCode: "HTK", Brand: "HITEKER" },
          { lineCode: "HUG", Brand: "HUGHES" },
          { lineCode: "HUN", Brand: "HUNTER" },
          { lineCode: "HUS", Brand: "Husqvarna" },
          { lineCode: "HWL", Brand: "HONEYWELL" },
          { lineCode: "HWN", Brand: "HEAT WAGON" },
          { lineCode: "HYD", Brand: "HYDROTECH" },
          { lineCode: "HYG", Brand: "HYDRO GEAR" },
          { lineCode: "HZN", Brand: "HORIZON FITNESS" },
          { lineCode: "IBM", Brand: "IBM" },
          { lineCode: "IBX", Brand: "IBM REFURB" },
          { lineCode: "ICE", Brand: "" },
          { lineCode: "ICP", Brand: "INT. CONFORT PARTS" },
          { lineCode: "ICR", Brand: "" },
          { lineCode: "IFT", Brand: "Infotainment" },
          { lineCode: "ILO", Brand: "ILO" },
          { lineCode: "ILX", Brand: "INNOLUX" },
          { lineCode: "IMP", Brand: "IMPORT" },
          { lineCode: "IMT", Brand: "COMPUTER PARTS" },
          { lineCode: "IND", Brand: "INDUSTRIAL AIR" },
          { lineCode: "INF", Brand: "INFOCUS" },
          { lineCode: "ING", Brand: "INGERSOLL RAND" },
          { lineCode: "INH", Brand: "Infratech" },
          { lineCode: "INO", Brand: "INOVATE" },
          { lineCode: "INT", Brand: "INTEL" },
          { lineCode: "IPR", Brand: "IMPRESSION" },
          { lineCode: "ISG", Brand: "INSIGNIA" },
          { lineCode: "ISY", Brand: "I-SYMPHONY" },
          { lineCode: "JAC", Brand: "JACQUES EBERT" },
          { lineCode: "JAN", Brand: "JANCY" },
          { lineCode: "JAP", Brand: "JAPANESE SEMIS" },
          { lineCode: "JAS", Brand: "JASON ILLINOIS INC" },
          { lineCode: "JBL", Brand: "JBL" },
          { lineCode: "JBR", Brand: "0" },
          { lineCode: "TTI", Brand: "Ryobi Elect. Tools" },
          { lineCode: "JCN", Brand: "JACKSON" },
          { lineCode: "JEN", Brand: "JENN-AIR" },
          { lineCode: "JET", Brand: "JET" },
          { lineCode: "JIG", Brand: "REPAIR JIG" },
          { lineCode: "JNY", Brand: "JENNY" },
          { lineCode: "JOG", Brand: "JOHN GUEST" },
          { lineCode: "JON", Brand: "JONSERED" },
          { lineCode: "JVA", Brand: "JVC/AMTRAN" },
          { lineCode: "JVC", Brand: "JVC" },
          { lineCode: "JWH", Brand: "J.W. HARRIS" },
          { lineCode: "JZI", Brand: "JACUZZI" },
          { lineCode: "KAB", Brand: "KABA ILCO" },
          { lineCode: "KAD", Brand: "KITCHEN AID" },
          { lineCode: "KAR", Brand: "KARCHER" },
          { lineCode: "KAS", Brand: "GENERIC COMPUTER" },
          { lineCode: "KAT", Brand: "KOVA" },
          { lineCode: "KAW", Brand: "Kawasaki" },
          { lineCode: "KDS", Brand: "KDS MONITORS" },
          { lineCode: "KDX", Brand: "KDSUSA INC REFURB" },
          { lineCode: "KEF", Brand: "KEF AUDIO" },
          { lineCode: "KEL", Brand: "KELON" },
          { lineCode: "KEN", Brand: "KENWOOD" },
          { lineCode: "KEW", Brand: "KENWOOD" },
          { lineCode: "KIR", Brand: "KIRBY" },
          { lineCode: "KIT", Brand: "APPLIANCE PARTS" },
          { lineCode: "KMR", Brand: "KENMORE-DAEWOO" },
          { lineCode: "KNA", Brand: "KNAACK" },
          { lineCode: "KNL", Brand: "KENDALL" },
          { lineCode: "KOB", Brand: "KOBALT" },
          { lineCode: "KOD", Brand: "KODAK" },
          { lineCode: "KOH", Brand: "KOHLER" },
          { lineCode: "KON", Brand: "KONKA" },
          { lineCode: "KOR", Brand: "KODAK REFURB" },
          { lineCode: "KRU", Brand: "KRUPS" },
          { lineCode: "KWD", Brand: "SCOPES & POWER SUPP." },
          { lineCode: "KYO", Brand: "KYOCERA MITA" },
          { lineCode: "LAN", Brand: "LANG" },
          { lineCode: "LAS", Brand: "LASKO" },
          { lineCode: "LAW", Brand: "LAWN BOY" },
          { lineCode: "LEH", Brand: "LENOVO RECERTIFIED" },
          { lineCode: "LEN", Brand: "LENOVO" },
          { lineCode: "LEX", Brand: "LEXMARK" },
          { lineCode: "LGE", Brand: "LG WIRELESS" },
          { lineCode: "ZEN", Brand: "LG" },
          { lineCode: "LIE", Brand: "LIEBHERR" },
          { lineCode: "LIF", Brand: "LIFTMASTER" },
          { lineCode: "LIN", Brand: "LINKSYS" },
          { lineCode: "LIT", Brand: "LITTLEFUSE" },
          { lineCode: "LMB", Brand: "LMB HEEGER" },
          { lineCode: "LMP", Brand: "LAMP ONLY" },
          { lineCode: "LNX", Brand: "LENNOX" },
          { lineCode: "LOK", Brand: "LOKRING APPLIANCE" },
          { lineCode: "LOR", Brand: "OBSERVATION STSYEMS" },
          { lineCode: "LOW", Brand: "LOWELL" },
          { lineCode: "LPS", Brand: "LPS" },
          { lineCode: "LPU", Brand: "GENERIC" },
          { lineCode: "LTW", Brand: "LITTLE WONDER" },
          { lineCode: "LUX", Brand: "LUXOR" },
          { lineCode: "LVR", Brand: "LIQUID VIDEO REFURB" },
          { lineCode: "LXA", Brand: "0" },
          { lineCode: "LXR", Brand: "LEXMARK REFURB" },
          { lineCode: "LYN", Brand: "LYNX" },
          { lineCode: "MAA", Brand: "MOTORS & ARMATURES" },
          { lineCode: "MAC", Brand: "MAGIC CHEF" },
          { lineCode: "MAE", Brand: "MA-LINE" },
          { lineCode: "MAG", Brand: "MAGNAVOX" },
          { lineCode: "MAJ", Brand: "MAJESTIC" },
          { lineCode: "MAK", Brand: "MAKITA" },
          { lineCode: "MAL", Brand: "MALLORY" },
          { lineCode: "MAR", Brand: "MARANTZ" },
          { lineCode: "MAS", Brand: "MASTER" },
          { lineCode: "MAT", Brand: "MATRIX FITNESS" },
          { lineCode: "MAX", Brand: "MAXELL" },
          { lineCode: "MAY", Brand: "MAYTAG/AMANA" },
          { lineCode: "MCC", Brand: "McCULLOCH" },
          { lineCode: "MCM", Brand: "MCM" },
          { lineCode: "MCS", Brand: "MICROSOFT" },
          { lineCode: "MDM", Brand: "MEDEX" },
          { lineCode: "MET", Brand: "METABO HPT - HITACHI" },
          { lineCode: "MGT", Brand: "MARGARITAVILLE" },
          { lineCode: "MIA", Brand: "MIAMI PARTS" },
          { lineCode: "MID", Brand: "MIDEA" },
          { lineCode: "MIE", Brand: "MIELE" },
          { lineCode: "MIL", Brand: "MILWAUKEE" },
          { lineCode: "MIM", Brand: "MI-T-M" },
          { lineCode: "MIN", Brand: "KONICA MINOLTA" },
          { lineCode: "MIR", Brand: "MIRACLE REMOTE" },
          { lineCode: "MIS", Brand: "MASS INTEGRATED" },
          { lineCode: "MIT", Brand: "MITSUBISHI" },
          { lineCode: "MKA", Brand: "MINN KOTA" },
          { lineCode: "MKD", Brand: "MK DIAMOND" },
          { lineCode: "MKF", Brand: "MARKET FORGE" },
          { lineCode: "MLM", Brand: "MIDLAND METAL" },
          { lineCode: "MMM", Brand: "3M FILTRETE PRODUCTS" },
          { lineCode: "MNN", Brand: "Monessen" },
          { lineCode: "MOE", Brand: "MOEN" },
          { lineCode: "MOT", Brand: "MOTOROLA" },
          { lineCode: "MRC", Brand: "MRCOOL" },
          { lineCode: "MRF", Brand: "MR COFFEE" },
          { lineCode: "MRH", Brand: "MR HEATER" },
          { lineCode: "MRO", Brand: "MIRRO" },
          { lineCode: "MRQ", Brand: "MARQUIS" },
          { lineCode: "MRX", Brand: "MOTOROLA REFURB" },
          { lineCode: "MSC", Brand: "PANASONIC" },
          { lineCode: "MSI", Brand: "MSI COMPUTER" },
          { lineCode: "MSL", Brand: "MATSUSHITA" },
          { lineCode: "MSR", Brand: "PANASONIC REFURB" },
          { lineCode: "MST", Brand: "MST" },
          { lineCode: "MTA", Brand: "MOTOROLA AFTER MKT" },
          { lineCode: "MTD", Brand: "TROY BILT YARDMAN" },
          { lineCode: "MTR", Brand: "MITSUBISHI REFURB" },
          { lineCode: "MTX", Brand: "MTX SPEAKERS" },
          { lineCode: "MUR", Brand: "MURATEC" },
          { lineCode: "MXP", Brand: "MAX PROFESSIONAL" },
          { lineCode: "MXX", Brand: "MAX" },
          { lineCode: "NAD", Brand: "NADY" },
          { lineCode: "NAL", Brand: "PHILIPS MANUALS" },
          { lineCode: "NAP", Brand: "PHILIPS" },
          { lineCode: "NCR", Brand: "NORELCO FINISHED" },
          { lineCode: "NDA", Brand: "APPL. INSTALL KITS" },
          { lineCode: "NDT", Brand: "NordicTrack" },
          { lineCode: "NEC", Brand: "NEC" },
          { lineCode: "NEO", Brand: "OSRAM NEOLUX" },
          { lineCode: "NES", Brand: "NESPRESSO" },
          { lineCode: "NEX", Brand: "NEXTBOOK USA" },
          { lineCode: "NGK", Brand: "SPARK PLUGS" },
          { lineCode: "NGL", Brand: "NEXGRILL" },
          { lineCode: "NKN", Brand: "NIKON" },
          { lineCode: "NOR", Brand: "NORELCO" },
          { lineCode: "NOV", Brand: "NOVATEK" },
          { lineCode: "NPL", Brand: "NAPOLEON" },
          { lineCode: "NPS", Brand: "ANDERIC" },
          { lineCode: "NSA", Brand: "NSA RECOVERY" },
          { lineCode: "NTE", Brand: "NTE ELECTRONICS" },
          { lineCode: "NTK", Brand: "NORTEK" },
          { lineCode: "NUK", Brand: "NUKOTE" },
          { lineCode: "NUM", Brand: "NUMEREX" },
          { lineCode: "NUO", Brand: "NUOVA SIMONELLI" },
          { lineCode: "NUT", Brand: "NUTONE" },
          { lineCode: "NWD", Brand: "GREEN CHOICE" },
          { lineCode: "NWS", Brand: "NEW WAVE SALES" },
          { lineCode: "NXX", Brand: "NEXXTECH" },
          { lineCode: "ODY", Brand: "ODYSSEY" },
          { lineCode: "OFC", Brand: "OFFICE SUPPLIES" },
          { lineCode: "OKI", Brand: "OKIDATA" },
          { lineCode: "OKR", Brand: "OKIDATA REFURB" },
          { lineCode: "OLE", Brand: "OLEVIA" },
          { lineCode: "OLY", Brand: "OLYMPUS" },
          { lineCode: "ONK", Brand: "ONKYO" },
          { lineCode: "OPL", Brand: "OPAL ICEMAKERS" },
          { lineCode: "OPT", Brand: "OPTOMA" },
          { lineCode: "ORB", Brand: "ORAL-B" },
          { lineCode: "ORE", Brand: "ORECK" },
          { lineCode: "ORG", Brand: "Oregon" },
          { lineCode: "ORI", Brand: "ORION" },
          { lineCode: "OSR", Brand: "OSRAM" },
          { lineCode: "OST", Brand: "Oster" },
          { lineCode: "PAC", Brand: "TOOLS" },
          { lineCode: "PAF", Brand: "PHILIPS PRODUCT" },
          { lineCode: "PAK", Brand: "PACKARD INC" },
          { lineCode: "PAR", Brand: "MEMORY PRODUCTS" },
          { lineCode: "PAT", Brand: "PATIO COMFORT" },
          { lineCode: "PBS", Brand: "PHILIPS HOSPITALITY" },
          { lineCode: "PCI", Brand: "PREMIUM COMPATIBLES" },
          { lineCode: "PCL", Brand: "PHILIPS LIFE STYLE" },
          { lineCode: "PCN", Brand: "PROSCAN" },
          { lineCode: "PCO", Brand: "MATV/CATV ACC" },
          { lineCode: "PDL", Brand: "PHILIPS DIRECT LIFE" },
          { lineCode: "PDT", Brand: "PANDUIT" },
          { lineCode: "PEG", Brand: "PEG PEREGO" },
          { lineCode: "PEN", Brand: "Penn" },
          { lineCode: "PER", Brand: "PERLICK" },
          { lineCode: "PET", Brand: "POLAROID" },
          { lineCode: "PFH", Brand: "PHILIPS HOSP. CANADA" },
          { lineCode: "PFL", Brand: "PFLUEGER" },
          { lineCode: "PGC", Brand: "PHILIPS GARMENT CARE" },
          { lineCode: "PGS", Brand: "PGS GRILL" },
          { lineCode: "PHC", Brand: "PHILIPS HEALTHY COOK" },
          { lineCode: "PHI", Brand: "PHILMORE" },
          { lineCode: "PHL", Brand: "PHILIPS LIGHTING" },
          { lineCode: "PHS", Brand: "Philips Health Solut" },
          { lineCode: "PHX", Brand: "PHOENIX LAMP" },
          { lineCode: "PIN", Brand: "PINNACLE SALES" },
          { lineCode: "PIO", Brand: "PIONEER" },
          { lineCode: "PIT", Brand: "PITCO" },
          { lineCode: "PKG", Brand: "PACKAGING" },
          { lineCode: "PLA", Brand: "PLASMAIR" },
          { lineCode: "PLC", Brand: "PERLICK" },
          { lineCode: "PLK", Brand: "POLK" },
          { lineCode: "PLT", Brand: "POLTI" },
          { lineCode: "PMT", Brand: "POWERMATIC" },
          { lineCode: "PNF", Brand: "PHILIPS" },
          { lineCode: "POR", Brand: "POLTI REFURBISHED" },
          { lineCode: "POU", Brand: "POULAN" },
          { lineCode: "POW", Brand: "POWERSONIC" },
          { lineCode: "PPA", Brand: "PEERLESS RANGE CO." },
          { lineCode: "PPH", Brand: "Philips Purifiers" },
          { lineCode: "PPP", Brand: "PARTPOINT PARTS" },
          { lineCode: "PRB", Brand: "BELT AND VCR ACC." },
          { lineCode: "PRE", Brand: "PRESTO" },
          { lineCode: "PRF", Brand: "PROFORM" },
          { lineCode: "PRP", Brand: "PRO TEMP" },
          { lineCode: "PRT", Brand: "PROTECTIVE COATING" },
          { lineCode: "PRV", Brand: "PROVIEW" },
          { lineCode: "PSX", Brand: "PROCTOR SILEX" },
          { lineCode: "PTA", Brand: "PETRA" },
          { lineCode: "PTC", Brand: "Porter Cable" },
          { lineCode: "PTR", Brand: "PENTAIR" },
          { lineCode: "PTS", Brand: "PTS MODULES" },
          { lineCode: "PWM", Brand: "POWERMATE" },
          { lineCode: "PWS", Brand: "POWER WHEELS" },
          { lineCode: "PWW", Brand: "PRIMA WORLDWIDE" },
          { lineCode: "QJO", Brand: "CELL PHONE" },
          { lineCode: "QST", Brand: "QST" },
          { lineCode: "QTM", Brand: "QUANTUM VIEW" },
          { lineCode: "QUA", Brand: "QUAM" },
          { lineCode: "QUE", Brand: "COMPUTER SOFTWARE" },
          { lineCode: "QVS", Brand: "COMPUTER CABLES" },
          { lineCode: "RAI", Brand: "RAIN BIRD" },
          { lineCode: "RAN", Brand: "RANDELL" },
          { lineCode: "RAW", Brand: "CHEMICALS" },
          { lineCode: "RAZ", Brand: "RAZOR" },
          { lineCode: "RCA", Brand: "RCA" },
          { lineCode: "RCL", Brand: "TCE TECHNICAL" },
          { lineCode: "RCX", Brand: "RICOH REFURBISHED" },
          { lineCode: "REB", Brand: "GREEN CHOICE" },
          { lineCode: "REC", Brand: "RECTORSEAL" },
          { lineCode: "RED", Brand: "REDMAX" },
          { lineCode: "REM", Brand: "REMINGTON" },
          { lineCode: "REP", Brand: "REPLACEMENT TRANSIST" },
          { lineCode: "RHE", Brand: "Rheem" },
          { lineCode: "RIC", Brand: "RICOH" },
          { lineCode: "RID", Brand: "RIDGID" },
          { lineCode: "RIE", Brand: "RITCHIE ENGINEERING" },
          { lineCode: "RIT", Brand: "RITE OFF" },
          { lineCode: "ROB", Brand: "ROBERTSHAW" },
          { lineCode: "ROC", Brand: "ROCKWELL" },
          { lineCode: "ROD", Brand: "ROBINAIR DIVISON" },
          { lineCode: "ROL", Brand: "ROLAIR" },
          { lineCode: "ROT", Brand: "ROTARY (AFTERMARKET)" },
          { lineCode: "ROW", Brand: "ROWENTA" },
          { lineCode: "ROY", Brand: "ROYAL" },
          { lineCode: "RTL", Brand: "GREEN CHOICE" },
          { lineCode: "RTV", Brand: "OPEN BOX PRODUCT" },
          { lineCode: "RTZ", Brand: "ROTOZIP" },
          { lineCode: "RUN", Brand: "RUNCO" },
          { lineCode: "RUU", Brand: "RUUD" },
          { lineCode: "SAE", Brand: "SAECO" },
          { lineCode: "SAM", Brand: "CELL PHONE PARTS" },
          { lineCode: "SAN", Brand: "SANITAIRE" },
          { lineCode: "SAT", Brand: "STEVENS APPLIANCE TR" },
          { lineCode: "SBD", Brand: "SOUTHBEND" },
          { lineCode: "SCE", Brand: "SCEPTRE" },
          { lineCode: "SCO", Brand: "SCOTSMAN" },
          { lineCode: "SCR", Brand: "SONICARE" },
          { lineCode: "SEI", Brand: "SEIKI" },
          { lineCode: "SEN", Brand: "SENSEO" },
          { lineCode: "SEP", Brand: "SENSIBLE PRODUCTS" },
          { lineCode: "SFS", Brand: "SANYO" },
          { lineCode: "SGG", Brand: "SMEG" },
          { lineCode: "SGM", Brand: "SIGMAC USA" },
          { lineCode: "SGO", Brand: "SUNGLO" },
          { lineCode: "SHA", Brand: "SHARP" },
          { lineCode: "SHI", Brand: "SHINDAIWA" },
          { lineCode: "SHK", Brand: "SHAKESPEARE" },
          { lineCode: "SHM", Brand: "SHIMANO" },
          { lineCode: "SHO", Brand: "SHOPVAC" },
          { lineCode: "SHT", Brand: "SUNHEAT" },
          { lineCode: "SIL", Brand: "SILHOUETTE" },
          { lineCode: "SIM", Brand: "SIMPLICITY" },
          { lineCode: "SJP", Brand: "GREEN CHOICE" },
          { lineCode: "SKI", Brand: "SKIL" },
          { lineCode: "SKU", Brand: "SKUTTLE" },
          { lineCode: "SLD", Brand: "SOUTHLAND" },
          { lineCode: "SLY", Brand: "STANLEY" },
          { lineCode: "SMC", Brand: "SANYO MANUFACTURING" },
          { lineCode: "SMD", Brand: "SMUDGETIP" },
          { lineCode: "SME", Brand: "SIMER" },
          { lineCode: "SMG", Brand: "SAMSUNG" },
          { lineCode: "SMR", Brand: "SAMSUNG REFURB" },
          { lineCode: "SMT", Brand: "SMART TECHNOLOGIES" },
          { lineCode: "SNA", Brand: "SNAPPER" },
          { lineCode: "SNC", Brand: "SENCO" },
          { lineCode: "SNS", Brand: "SONOS" },
          { lineCode: "SNY", Brand: "SONY ACCESSORIES" },
          { lineCode: "SOH", Brand: "GREEN CHOICE" },
          { lineCode: "SON", Brand: "SONY" },
          { lineCode: "SOU", Brand: "SOUNDLIER" },
          { lineCode: "SPA", Brand: "BAYSTATE POOL" },
          { lineCode: "SPC", Brand: "COMMERCIAL WATER DIS" },
          { lineCode: "SPE", Brand: "SPECTRUM" },
          { lineCode: "SPK", Brand: "SUNPAK" },
          { lineCode: "SPQ", Brand: "SPEED QUEEN" },
          { lineCode: "SPR", Brand: "SPECTRUM REFURBISHED" },
          { lineCode: "SPT", Brand: "SPRAYTECH" },
          { lineCode: "SRC", Brand: "MISC" },
          { lineCode: "SRK", Brand: "SHARK" },
          { lineCode: "SRN", Brand: "Subaru / Robin" },
          { lineCode: "SSL", Brand: "SONY SERVICE LIT." },
          { lineCode: "SST", Brand: "SUN-STREAM" },
          { lineCode: "STA", Brand: "STAR" },
          { lineCode: "STC", Brand: "STANCO" },
          { lineCode: "STE", Brand: "STERLING" },
          { lineCode: "STL", Brand: "STARLOGIC REFURBISH" },
          { lineCode: "STM", Brand: "SYSTEMAX" },
          { lineCode: "STN", Brand: "XFMRS & SOLENOIDS" },
          { lineCode: "STR", Brand: "Star Trac" },
          { lineCode: "SUB", Brand: "SUB ZERO" },
          { lineCode: "SUI", Brand: "SUBARU INDUSTRIAL" },
          { lineCode: "SUM", Brand: "SUMMIT BRANDS" },
          { lineCode: "SUN", Brand: "SUNBEAM" },
          { lineCode: "SUP", Brand: "SUPPLIES" },
          { lineCode: "SUR", Brand: "Sure Flame" },
          { lineCode: "SVA", Brand: "SVA" },
          { lineCode: "SWI", Brand: "SWITCHCRAFT" },
          { lineCode: "SYL", Brand: "SYLVANIA" },
          { lineCode: "SYR", Brand: "SOYO REFURBISHED" },
          { lineCode: "T-F", Brand: "T-FAL" },
          { lineCode: "TAN", Brand: "TANAKA" },
          { lineCode: "TBA", Brand: "TOSHIBA" },
          { lineCode: "TCL", Brand: "TCL" },
          { lineCode: "TEC", Brand: "TECH SPRAY" },
          { lineCode: "TEP", Brand: "TECUMSEH PEERLESS" },
          { lineCode: "TGC", Brand: "THE GOOD CLEAN" },
          { lineCode: "THO", Brand: "THOR" },
          { lineCode: "THT", Brand: "THERMOFLUID TECH" },
          { lineCode: "TIT", Brand: "TITAN" },
          { lineCode: "TKK", Brand: "FRS RADIO" },
          { lineCode: "TKX", Brand: "TEKTRONIX" },
          { lineCode: "TMP", Brand: "TEMPUR-PEDIC" },
          { lineCode: "TMT", Brand: "TOM TOM" },
          { lineCode: "TNT", Brand: "TNT" },
          { lineCode: "TOR", Brand: "TORO" },
          { lineCode: "TOS", Brand: "TOSHIBA COMPUTER" },
          { lineCode: "TPV", Brand: "TPV TECHNOLOGY" },
          { lineCode: "TRA", Brand: "TRADEPRO" },
          { lineCode: "TRI", Brand: "TRIPP-LITE" },
          { lineCode: "TRN", Brand: "TRANE" },
          { lineCode: "TRU", Brand: "1" },
          { lineCode: "TSH", Brand: "TECUMSEH" },
          { lineCode: "TSM", Brand: "TRI-STATE MODULE" },
          { lineCode: "TST", Brand: "TEST PARTS" },
          { lineCode: "TTI", Brand: "RYOBI" },
          { lineCode: "TTW", Brand: "TITAN TANKLESS WATER" },
          { lineCode: "TUT", Brand: "TUTCO HEATING SOLUTI" },
          { lineCode: "TWI", Brand: "TWIN EAGLES" },
          { lineCode: "ULE", Brand: "UNIVERSAL ENT" },
          { lineCode: "ULN", Brand: "U-LINE" },
          { lineCode: "UNI", Brand: "UNIWELD" },
          { lineCode: "USD", Brand: "USD PRODUCTS" },
          { lineCode: "USP", Brand: "RECHARGEABLE BATTERY" },
          { lineCode: "USS", Brand: "US STOVE COMPANY" },
          { lineCode: "VAI", Brand: "VAIN STHLM" },
          { lineCode: "VAN", Brand: "VANCO" },
          { lineCode: "VAP", Brand: "VAPCO PRODUCTS" },
          { lineCode: "VBI", Brand: "MISC." },
          { lineCode: "VEL", Brand: "TEST EQUIPMENT" },
          { lineCode: "VEN", Brand: "Vent-A-Hood" },
          { lineCode: "VER", Brand: "VERMONT" },
          { lineCode: "VGA", Brand: "VIDEO GAMING ADV" },
          { lineCode: "VIK", Brand: "VIKING APPLIANCES" },
          { lineCode: "VIO", Brand: "VIORE" },
          { lineCode: "VIR", Brand: "VIRGINIA AIR" },
          { lineCode: "VIS", Brand: "VISION FITNESS" },
          { lineCode: "VIV", Brand: "VIVITEK" },
          { lineCode: "VIZ", Brand: "VIZIO" },
          { lineCode: "VMP", Brand: "VIDEO MOUNT PRODUCTS" },
          { lineCode: "VRG", Brand: "VERGE" },
          { lineCode: "VSR", Brand: "V7E ELECT. REFURBISH" },
          { lineCode: "VUL", Brand: "VULCAN HART" },
          { lineCode: "VWS", Brand: "VIEWSONIC REFURB" },
          { lineCode: "VZP", Brand: "VIZPARTS" },
          { lineCode: "WAG", Brand: "WAGNER" },
          { lineCode: "WAL", Brand: "WALBRO" },
          { lineCode: "WAR", Brand: "WARING" },
          { lineCode: "WBR", Brand: "WEBER" },
          { lineCode: "WDE", Brand: "WESTINGHOUSE" },
          { lineCode: "WDR", Brand: "WESTERN DIG. REFURB" },
          { lineCode: "WEA", Brand: "WEATHER GUARD" },
          { lineCode: "WEB", Brand: "POWER CORDS" },
          { lineCode: "WEE", Brand: "WEED EATER" },
          { lineCode: "WEL", Brand: "WELLS" },
          { lineCode: "WES", Brand: "WEST PENN" },
          { lineCode: "WFS", Brand: "WOOD FINISHING" },
          { lineCode: "WHI", Brand: "Whirlpool" },
          { lineCode: "WHR", Brand: "WHITE-RODGERS" },
          { lineCode: "WII", Brand: "WII NINTENDO" },
          { lineCode: "WIK", Brand: "WIKO LAMPS" },
          { lineCode: "WIL", Brand: "WILTON" },
          { lineCode: "WIN", Brand: "WINEGARD" },
          { lineCode: "WIS", Brand: "WISTRON" },
          { lineCode: "WLK", Brand: "WALKER & SONS" },
          { lineCode: "WLT", Brand: "WELTON" },
          { lineCode: "WMN", Brand: "WHITE MOUNTAIN" },
          { lineCode: "WOL", Brand: "WOLF APPLIANCE" },
          { lineCode: "WOR", Brand: "WORX" },
          { lineCode: "WSL", Brand: "WESLO" },
          { lineCode: "WYS", Brand: "WYSE" },
          { lineCode: "XAN", Brand: "XANTUS PRODUCTS" },
          { lineCode: "XER", Brand: "XEROX" },
          { lineCode: "XTG", Brand: "X2GEN REFURBISHED" },
          { lineCode: "YAM", Brand: "YAMAHA" },
          { lineCode: "YAR", Brand: "YARD MAN" },
          { lineCode: "YCX", Brand: "YC" },
          { lineCode: "YEA", Brand: "YEATS DOLLY" },
          { lineCode: "YOR", Brand: "YORK" },
          { lineCode: "ZAM", Brand: "ZAMA" },
          { lineCode: "ZEB", Brand: "ZEBRA" },
          { lineCode: "ZEN", Brand: "LG" },
          { lineCode: "ZER", Brand: "LG ELECTRONICS REFUR" },
          { lineCode: "ZOD", Brand: "ZODIAC" },
          { lineCode: "ZTS", Brand: "ZT SYSTEMS" },
        ];

      
        var NewHtml = '';
        $(document).find(".suggestion-list").empty();

        setTimeout(function() {
      
          const formatString = (str) =>
            str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

            // Sort the products so ones with valid image URLs appear first
            const sortedProducts = product_search?.nodes?.sort((a, b) => {
            const hasImageA = a.images?.nodes?.[0]?.originalSrc ? 1 : 0;
            const hasImageB = b.images?.nodes?.[0]?.originalSrc ? 1 : 0;
              return hasImageB - hasImageA; // sort descending: products with images first
            });

            sortedProducts?.forEach((product) => {
            const tags = product.tags;
            const title = product.title;
            const images = product.images;
            const vendor = product.vendor;
            const handle = product.handle;
            const variants = product.variants;
            const brandName = vendor;

            const matchingBrand = Brand_json.find(
              (item) => formatString(item.Brand) === formatString(brandName)
            );

            let lineCode = matchingBrand?.lineCode || "";

            let amount = variants?.nodes?.[0]?.price?.amount || "";

            const sku = variants?.nodes?.[0]?.sku || "";
            const variantsid = variants?.nodes?.[0]?.id || "";
            const variIdFilter = variantsid.split("/").pop();

            let btnFAddVDet = '' ;
            let finamt = ''
            if(amount == '0.0' ){
              finamt = '';
              btnFAddVDet = `<button class="view_detials_btn linkclass add_to_cart_SF">
                <div class="cart_icon_img">
                </div>
                <span class="text">View detail</span>
              </button>`;
            }else{
              finamt = `$${amount}`;
              btnFAddVDet = `<button data-pid="${variIdFilter}" class="js_add_to_cart_button add_to_cart_SF linkclass">
                <div class="cart_icon_img">
                  <img src="https://cdn.shopify.com/s/files/1/0700/0293/3937/files/cardbag.svg?v=1745224987">
                </div>
                <span class="text">Add to Cart</span>
              </button>`;
            }

            let imagesrc = "";
            if (images?.nodes?.length > 0 && images.nodes[0]?.originalSrc) {
              imagesrc = images.nodes[0].originalSrc;
            } else {
              imagesrc =
                "https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=" +
                lineCode +
                "&type=b&size=s";
            }

            const truncatedTitle =
              title.length > 50 ? title.substring(0, 50) + "..." : title;

            $('.loaderfilter').hide();

            let brandhtml = `<div class="app productDatalist NewOneForBrand">
                                <a class="brnd_arch" href="products/${handle}">
                                  <div class="sel_brnd_img dfgff">
                                    <img class="brnd_img" src="${imagesrc}">
                                  </div>
                                </a>
                                <a class="brnd_arch" href="products/${handle}">
                                  <p class="brnd_title">${truncatedTitle}</p>
                                  <p class="brnd_sku" style="display:none;">${sku}</p>
                                  <p class="brnd_pro_price">${finamt}</p>
                                  <p class="brnd_vendor">${vendor}</p>
                                </a>
                                ${btnFAddVDet}
                              </div>`;


            $(".suggestion-list").append(brandhtml);
            $(".brand-item").css({ "pointer-events": "auto" });
            $(".loader_filter").css("display", "none");

          });
         
          setTimeout(() => {
              if (product_search.nodes.length > 5) {
                  $slider.slick({
                    lazyLoad: "ondemand",
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: true,
                    speed: 500,
                    responsive: [
                      {
                        breakpoint: 1600,
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 2,
                          infinite: true,
                          dots: true
                        }
                      },
                      {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll: 1,
                          infinite: true,
                          dots: true
                        }
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                        }
                      }
                    ]
                  });
              }
          }, 300);
          

        }, 700);

  
      }
      
    })
    .catch((error) => {
      console.error("Error:", error);
    });


}
  

var productDetails = [];
var search_Attr = '';
var new_array = [];

  $(document).ready(function () {
  var cat_name = '';
  var valSear = '';
  var brandAttr = '';
    // console.log("text")
  cat_name = $(".filter-btn.active").attr("data-cat-name");
  // console.log("cat_name>>>>>>>>>>>",cat_name);
  //call function with cat_name defualt
    getApiProData(cat_name,'','');
    
  $(".filter-btn").click(function () {
     $("section.search_with_bg .brand-item").removeClass("zoomed");
    $('.searcfilter').val("")
    $('.loader_filter').css('display','block')
     cat_name = $(this).attr("data-cat-name");
      // console.log("cat_name",cat_name);
    getApiProData(cat_name,'','')
     //call function with cat_name
  })

  $(document).off("click", ".brand-item").on("click", ".brand-item", function () {
    $('.searcfilter').val("")
       $('.brand-item').css({
      // "pointer-events": "none"
    });
    
   $('.loader_filter').css('display','block')
      $(".brand-item").removeClass("active");
      $(this).addClass("active");
        brandAttr = $(this).attr("brand-attr").toLowerCase();
        cat_name = $(".filter-btn.active").attr("data-cat-name");
        //  console.log("cat_name + Brand", cat_name+ " : "+brandAttr);
     getApiProData(cat_name,'',brandAttr)
        //call function with brand and cat_name
    });
    
    $('.js_btn_search').click(function(){
      $('.loader_filter').css('display','block')
        var inputValue = '';
   var selectedBrand = '';
  var water_filter =  $('.London').find('.searcfilter').val();
  var ice_maker = $('.icemaker').find('.searcfilter').val();
  var remote_controls = $('.Paris').find('.searcfilter').val();

  let valSear1 = '';

   if (water_filter) {
    valSear1 = water_filter;
  } else if (ice_maker) {
    valSear1 = ice_maker;
  } else if (remote_controls) {
    valSear1 = remote_controls;
  } else {
    // console.log("No search input provided.");
     $('.suggestion-list').removeClass('hidden-important');
     $('.loader_filter').hide();
     $('.mesaage_forData').hide();
  }

  valSear = valSear1; 

  // console.log("valSear1",valSear1)

   // ✅ If inputValue is blank, then trigger getApiProData
    if (valSear1.trim() === '') {
      // console.log("input field is blank")
        // Ensure cat_name exists or set default value
        // var cat_name = typeof cat_name !== 'undefined' ? cat_name : '';
       getApiProData(cat_name,'',brandAttr)
    }else{

       cat_name = $(".filter-btn.active").attr("data-cat-name");
      // console.log("valSear + cat_name + Brand", valSear+ " : "+ cat_name  );
    getApiProData(cat_name,valSear,'')
  //  $("section.search_with_bg .brand-item").removeClass("zoomed");   
  }
    });
  // $(document).on("click", "#search, #Airsearch, #Icesearch", function () {
  //     valSear = $.trim($(this).val());
  //     console.log("valSear", valSear);
  //     cat_name = $(".filter-btn.active").attr("data-cat-name");
  //     console.log("valSear + cat_name + Brand", valSear+ " : "+ cat_name  );
  //   getApiProData(cat_name,valSear,'')

  //   })

    // console.log("cat_name>>>>",cat_name,"valSear>>>>>",valSear,"brandAttr>>>>",brandAttr)



  });
$(document).ready(function () {
  $("section.search_with_bg .brand-item").on("click", function () {
    // Remove 'zoomed' class from all articles
    $("section.search_with_bg .brand-item").removeClass("zoomed");
  

    // Add 'zoomed' class to the clicked article
    $(this).addClass("zoomed");
   // $('.section.search_with_bg .brand-item').css("pointer-events", "none");
 

    
  });
});

// console.log("$(document).find('.suggestion-list')>>>",$(document).find('.suggestion-list'))

if ($(".suggestion-list").children().length > 0) {
  // console.log("inside the suggestion list");
  $(".search-product").css("display", "none");
} else {
  // console.log("elseshreya>>>");

  $(".search-product").css("display", "block");
}



// $(document).on("input", "#search, #Airsearch, #Icesearch", function () {
  // console.log("display input>>>", $(this).val());

  // var valSear = $.trim($(this).val());
  // console.log("valSear", valSear);

  // if ($.trim($(this).val()) == "") {
  //   console.log("blank")
  //   $("section.search_with_bg .brand-item").removeClass("zoomed");

  //   $(".suggestion-list").css("display", "block");
  //   $(".suggestion-list").addClass("hidden-important");
  //   // $('.suggestion-list').addClass('hidden');

  //   $(".water-filter-def-prod").show();
  //   $(".remote-controler-def-prod").show();
  //   $(".ice-maker-def-prod").show();
  //   $(".search-product").css("display", "block");
  //   $(".search-product").addClass("ActiveBox");
  //   $(".mesaage_forData").css("display","none");
  // }
  // if (valSear) {
  //   setTimeout(function(){
  //   $('.mesaage_forData').css('display','block')
  //     }, 5000);
  //   // console.log("Not Blank")
  //   $(".suggestion-list").removeClass("hidden");
  //   $(".suggestion-list").removeClass("hidden-important");
  //   $(".suggestion-list").css("display", "block");
  //   $(".search-product").css("display", "none");
  //   $(".search-product").removeClass("ActiveBox");
  //   $(".water-filter-def-prod").hide();
  //   $(".remote-controler-def-prod").hide();
  //   $(".ice-maker-def-prod").hide();
  // }
// });

// $(document).ready(function () {
//   $("section.search_with_bg .brand-item").on("click", function () {
//     // Remove 'zoomed' class from all articles
//     $("section.search_with_bg .brand-item").removeClass("zoomed");

//     // Add 'zoomed' class to the clicked article
//     $(this).addClass("zoomed");
//   });
// });

}  // end if condition of template
